import React from 'react';
import { Link } from 'gatsby';

const FooterIcon = () => (
  <Link to="/"><img src={require("./ConsultFGC_Logo_footer.png")} alt="Footer ConsultFGC Icon" ></img></Link>
);

export default FooterIcon;

/*

const LogoIcon = () => (
  <a href="#features"><img src={ logo } alt="FGC Icon" ></img></a>
);

export default LogoIcon;
*/
